export const initSearchSpecialNeeds = () => {
  const search = document.getElementById("search") as HTMLDivElement;

  if (!search) {
    return;
  }

  const specialNeedsInputAll: NodeListOf<HTMLInputElement> =
    search.querySelectorAll(".special-needs input");
  const specialNeedsTypesWrappers: NodeListOf<HTMLDivElement> =
    search.querySelectorAll(".special-needs-types");

  specialNeedsInputAll.forEach((specialNeedsInput) => {
    specialNeedsInput.addEventListener("change", () => {
      if (specialNeedsInput.checked) {
        specialNeedsTypesWrappers.forEach((specialNeedsTypes) => {
          specialNeedsTypes.classList.remove("d-none");
        });

        return;
      }

      specialNeedsTypesWrappers.forEach((specialNeedsTypes) => {
        specialNeedsTypes.classList.add("d-none");
      });
    });
  });
};
